function deleteGroupDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/delete-group/delete-group-dialog.html?$$REVISION$$'
  }
}

export { deleteGroupDialogDirective }
